import HeroSection from './components/HeroSection';
import BrandPhilosophy from './components/BrandPhilosophy';
import StyleManifesto from './components/StyleManifesto';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryShowcase from './components/CategoryShowcase';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import type { FC } from 'react';

const Home: FC = () => {
  return (
    <main>
      <HeroSection />
      <BrandPhilosophy />
      <StyleManifesto />
      <FeaturedArticles />
      <CategoryShowcase />
      <FAQSection />
      <CTASection />
    </main>
  );
};

export default Home;